import React, { Component } from 'react';
import {
	Banner,
	ColumnSection,
	PostItem,
	ProductModal,
	Section,
	Seo,
	Service,
	Step,
	Tab,
	TabsContainer,
	TabsHeader,
	Video,
} from '../components/ui';
import devices from '../assets/images/header-image.png';
import lang from '../assets/lang/';

class Home extends Component {

	state = {
		activeModal: null,
	};

	showModalHandler = (index) => {
		this.setState({ activeModal: index });
	};

	hideModalHandler = () => {
		this.setState({ activeModal: null });
	};

	render() {
		const getVideoBackground = () => {
			let videoBackground;
			if (window.devicePixelRatio > 1) {
				videoBackground = require('../assets/images/about/office_2@2x.jpg');
			} else {
				videoBackground = require('../assets/images/about/office_2.jpg');
			}
			return videoBackground;
		};

		const getServices = () =>
			lang.whatWeDo.map(service =>
				<Service
					key={service.image}
					title={service.text}
					text={service.text}
					image={service.image}
					link={service.text}
					data-wow-delay={service.animationDelay}
					data-wow-duration={service.animationDuration} />,
			);

		const getFirstSectionProducts = (type) => {
			if (type === 'keys') {
				return lang.products.slice(0, 3).map((product, index) =>
					<Tab
						key={product.title}
						tabId={product.id}
						tabTitle={product.title}
						tabIcon={product.icon}
						type='key'
						active={index === 0} />,
				);
			}

			return lang.products.map((product, index) =>
				<Tab
					key={product.title}
					tabId={product.id}
					tabTitle={product.title}
					tabText={product.text.slice(0, 100)}
					tabImage={product.image}
					tabIcon={product.icon}
					tabCategory={product.category}
					tabRow1={product.contentRow1}
					tabRow2={product.contentRow2}
					tabRow3={product.contentRow3}
					tabRow4={product.contentRow4}
					tabLink={product.link}
					active={index === 0}
					clicked={() => this.showModalHandler(index)}
					screenShot={product.screenshot}
					buttonText={product.readButtonText} />,
			);
		};

		const getSecondSectionProducts = (type) => {
			if (type === 'keys') {
				return lang.products.slice(3, 5).map((product, index) =>
					<Tab
						key={product.title}
						tabId={product.id}
						tabTitle={product.title}
						tabIcon={product.icon}
						type='key' />,
				);
			}

			return lang.products.map((product, index) =>
				<Tab
					key={product.title}
					tabId={product.id}
					tabTitle={product.title}
					tabText={product.text.slice(0, 100)}
					tabImage={product.image}
					tabCategory={product.category}
					tabRow1={product.contentRow1}
					tabRow2={product.contentRow2}
					tabRow3={product.contentRow3}
					tabRow4={product.contentRow4}
					tabIcon={product.icon}
					tabLink={product.link}
					active={index === 0}
					clicked={() => this.showModalHandler(index)}
					screenShot={product.screenshot}
					buttonText={product.readButtonText} />,
			);
		};

		const getThirdSectionProducts = (type) => {
			if (type === 'keys') {
				return lang.products.slice(5, 8).map((product, index) =>
					<Tab
						key={product.title}
						tabId={product.id}
						tabTitle={product.title}
						tabIcon={product.icon}
						type='key' />,
				);
			}

			return lang.products.map((product, index) =>
				<Tab
					key={product.title}
					tabId={product.id}
					tabTitle={product.title}
					tabText={product.text.slice(0, 100)}
					tabImage={product.image}
					tabCategory={product.category}
					tabRow1={product.contentRow1}
					tabRow2={product.contentRow2}
					tabRow3={product.contentRow3}
					tabRow4={product.contentRow4}
					tabIcon={product.icon}
					tabLink={product.link}
					active={index === 0}
					clicked={() => this.showModalHandler(index)}
					screenShot={product.screenshot}
					buttonText={product.readButtonText} />,
			);
		};

		const getForthSectionProducts = (type) => {
			if (type === 'keys') {
				return lang.products.slice(8).map((product, index) =>
					<Tab
						key={product.title}
						tabId={product.id}
						tabTitle={product.title}
						tabIcon={product.icon}
						style={{ borderRadius: 28, marginRight: 0, borderLeft: '1px solid #d0d0d0'}}
						type='key' />,
				);
			}

			return lang.products.map((product, index) =>
				<Tab
					key={product.title}
					tabId={product.id}
					tabTitle={product.title}
					tabText={product.text.slice(0, 100)}
					tabImage={product.image}
					tabCategory={product.category}
					tabRow1={product.contentRow1}
					tabRow2={product.contentRow2}
					tabRow3={product.contentRow3}
					tabRow4={product.contentRow4}
					tabIcon={product.icon}
					tabLink={product.link}
					active={index === 0}
					clicked={() => this.showModalHandler(index)}
					screenShot={product.screenshot}
					buttonText={product.readButtonText} />,
			);
		};


		const getSteps = () =>
			lang.steps.map(step =>
				<Step
					key={step.count}
					title={step.title}
					count={step.count}
					image={step.image}
					data-wow-delay={step.animationDelay}
					data-wow-duration={step.animationDuration} />,
			);

		const getPosts = () =>
			lang.posts.reverse().slice(0, 3).map(post =>
				<PostItem
					key={post.title}
					title={post.title}
					image={post.image}
					link={post.link}
					author={post.author}
					authorImage={post.authorImage}
					postType='thumbnail'
					data-wow-delay={post.animationDelay}
					data-wow-duration={post.animationDuration}
				/>,
			);

		const getModals = () =>
			lang.products.map((product, index) =>
				<ProductModal
					key={product.title}
					showModal={this.state.activeModal === index}
					hideModal={this.hideModalHandler}
					title={product.title}
					text={product.text}
					image={product.image}
					screenShot={product.screenshot}
					link={product.link}
					visitButton={product.visitButtonText}
				/>,
			);

		return (
			<div>
				<Seo
					pageTitle={lang.homeSeo.pageTitle}
					metaDescription={lang.homeSeo.metaDescription}
					metaKeywords={lang.homeSeo.metaKeywords}
				/>
				{getModals()}

				<Banner
					title={lang.titleBanner}
					text={lang.textBanner}
					buttonText={lang.buttonTextBanner}
					buttonLink={lang.buttonLinkBanner}
					sideImage={devices} />

				<Section sectionType='what-we-do' title={lang.titleWhatWeDo} text={lang.textWhatWeDo}>
					{getServices()}
				</Section>

				<Section sectionType='about-us'>
					<ColumnSection
						title={lang.titleAboutUsSection}
						text={lang.titleAboutUs}
						contentTitle={lang.titleAboutUsContent}
						contentText={lang.textAboutUSContent}
						icon='flaticon-cut' />

					<Video
						image={getVideoBackground()}
						video='https://www.youtube.com/watch?v=tqg3F-8jBec'
						buttonSubtitle={lang.buttonSubtitleVideo}
						buttonTitle={lang.buttonTitleVideo}
						link={lang.buttonLinkVideo} />
				</Section>

				<Section sectionType='project-steps' title={lang.titleSteps} text={lang.textSteps}>
					{getSteps()}
				</Section>

				<Section sectionType='tabs'>
					<TabsHeader
						title={lang.titleProductsSection}
						subtitle={lang.subtitleProductsSection}
						text={lang.textProductsSection}>

						{getFirstSectionProducts('keys')}
						{getSecondSectionProducts('keys')}
						{getThirdSectionProducts('keys')}
						{getForthSectionProducts('keys')}
					</TabsHeader>

					<TabsContainer image={'bg3.jpg'}>
						{getFirstSectionProducts()}
					</TabsContainer>
				</Section>
				<Section sectionType='news' title={lang.titleNews} text={lang.textNews}>
					{getPosts()}
				</Section>
			</div>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js